module.exports = __webpack_public_path__ + "static/003_body-landscape-bb95a6452c2721bdf9be6e89392544bf.mp4";